import styled from '@emotion/styled';

import SkeletonLoading from '../../../shared/components/Loading/SkeletonLoading';

const Event = styled.div`
  width: 1050px;
  margin: 0 auto 10px;
`;

function LoadingEventItem() {
  return (
    <>
      <Event>
        <SkeletonLoading width={1050} height={200} />
      </Event>
    </>
  );
}

export default function LoadingEvent() {
  return (
    <>
      <LoadingEventItem />
      <LoadingEventItem />
      <LoadingEventItem />
      <LoadingEventItem />
      <LoadingEventItem />
      <LoadingEventItem />
    </>
  );
}
